<template>
    <!-- 
    ui-grouping-definition | uiGroupingDefinition

    Permite generar dinámicamente campos, se usa en conjunto con 
    ConceptBehavior.inc@1.8.0 o superior, ya que requiere en 
    el behavior la definición de $groupingDefinitions como se muestra en su ejemplo. 
    
    @version 1.0
    @author Daniel Lepe
    @date 24 de enero, 2025
    -->
    <div class="ui-grouping-definition">
        
        <b-input-group>
            <b-form-input :value="value" :key="localId" @click="triggerModal" @mousedown.prevent="() => { }" :placeholder="placeholder"/>
            <b-input-group-append v-if="!readonly" class="hide-on-print">
                <b-button variant="info" v-if="!required && !isEmpty" @click="setClean">
                    <i class="fa fa-times"></i>
                </b-button>
                <b-button v-if="!readonly" @click="triggerModal"><i class="fa fa-search"></i></b-button>
            </b-input-group-append>
        </b-input-group>
        <div class="debug" v-if="debug"><pre>{{ value }}</pre></div>
        <b-modal modal-class="uiGroupingDefinition" v-model="displayModal" 
            :size="size" 
            :title="label"
            :hide-footer="hideButtons" 
            scrollable 
            no-enforce-focus 
            no-body 
            no-gutter 
            no-close-on-backdrop
            no-close-on-esc>

            <b-input-group class="mb-3">
                <b-form-input v-model="filter" :placeholder="placeholder"/>
                <b-input-group-append class="hide-on-print">
                    <b-button variant="info" v-if="filter.length" @click="filter = ''">
                        <i class="fa fa-times"></i>
                    </b-button>
                    <b-button variant="primary" @click="addEntry" v-if="canAddFromFilter && !disableAdding">
                        Add entry
                    </b-button>
                </b-input-group-append>
            </b-input-group>

            <b-list-group class="no-user-select">
                <b-list-group-item v-for="item in cOptions" :key="item" :active="workingValue == item"
                    @click="(workingValue = (workingValue != item) ? item : null); triggerSelect($event)">
                    {{ item }}
                </b-list-group-item>
            </b-list-group>

            <div class="debug" v-if="debug">
                <pre>{{ localOptions }}</pre>
                <pre>
                    {{ cOptions }}
                </pre>
            </div>


            <template v-slot:modal-footer="{ cancel }" v-if="!hideButtons && false">
                <b-button-group size="sm">
                    <b-button @click="cancel()" v-if="cancelLabel">{{ cancelLabel }}</b-button>
                    <slot name="extra-buttons"></slot>
                    <b-button @click="triggerSelect($event)" variant="primary" v-if="applyButton" :disabled="!workingValue">
                        {{ applyButton }}
                    </b-button>
                </b-button-group>
            </template>

        </b-modal>
    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'uiGroupingDefinition',
    props: {
        placeholder: {
            type: String,
            default: 'Type to filter or add...'
        },
        required: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        kIndex: {
            type: [Number, String],
        },
        fArchKey: {
            type: String
        },
        debug: {
            type: Boolean,
            default: false
        },
        unSelectedLabel: {
            type: [String],
            default: 'Unselected'
        },
        cancelLabel: {
            type: [String, Boolean],
            default: 'Cancel'
        },
        disableAdding: {
            type: Boolean,
            default: false
        },
        applyButton: {
            type: [String, Boolean, Number],
            default: "Select",
        },
        hideButtons: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: 'Options'
        },
        value: {
            type: [String, Number]
        },
        // valueName: {
        //     type: String,
        //     default: 'id'
        // },
        // labelName: {
        //     type: String,
        //     default: 'label'
        // },
        options: {
            type: Array,
            default: () => { return [] }
        },
        size: {
            type: String,
            default: 'sm'
        },
        args: {
            type: [Array, Object]
        }
    },
    computed: {
        canAddFromFilter(){
            return (this.filter.length > 3 && this.cOptionsUnFiltered.indexOf(this.filter.trim()) == -1)
        },
        isEmpty() {
            return (!this.value || this.value == '')
        },
        noOptionsAvailableFound() {
            return (this.cOptions.length == 0)
        },
        cOptions() {
            let allOptions = (_.concat(this.options, this.localOptions)).filter(item =>
                (item||'').toLowerCase().includes((this.filter||'').toLowerCase().trim())
            )
            if (this.workingValue && allOptions.indexOf(this.workingValue) == -1)
                allOptions.unshift(this.workingValue)
            return allOptions;
        },
        cOptionsUnFiltered() {
            return _.concat(this.options, this.localOptions)
        }
    },
    data: () => {
        return {
            localId: null,
            filter: '',
            workingValue: null,
            localOptions: [],
            workingItem: null,
            displayModal: false
        }
    },
    methods: {
        addEntry(){
            if(this.canAddFromFilter){
                this.localOptions.unshift(this.filter.trim())
                this.workingValue = this.filter.trim();
                this.filter = '';
            }
        },
        refreshed() {
            this.workingValue = null;
        },
        triggerSelect() {
            // if (this.value.trim() == this.workingValue.trim())
            // this.$emit('input', null)
            // else
            this.$emit('input', _.clone(this.workingValue))
            this.$nextTick(() => {
                this.displayModal = false;
                this.$emit('changed')
            })
        },
        setClean() {
            this.workingValue = '';
            this.triggerSelect()
        },
        triggerModal() {
            try {
                if(this.value && this.filter == '')
                    this.filter = _.clone(this.value)
                if (!this.readonly)
                    this.displayModal = true
            } catch (e) {
                console.error(e)
            }
        }
    },
    watch: {
        value() {
            if (this.value != this.workingValue) {
                console.log('Changed!')
                this.workingValue = _.clone(this.value)
            }
        }
    },
    beforeMount() {
        this.localId = _.uniqueId('grouping-definition-')
        this.workingValue = _.clone(this.value)
    }
}

</script>

<style lang="scss">
.no-user-select {
    user-select: none;
    cursor: pointer;
}
</style>